import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';

import { filtersToQuery } from '../../../helpers/filters';

import { API_HOST } from '../../../config/app-const';
import { normalize } from '../../../helpers/pagination';
import { uniqBy } from 'lodash';

const state = {
  outlets: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_OUTLETS_BUSY: (state, payload) => {
    state.outlets.isBusy = payload;
  },
  CLEAR_OUTLETS: (state, payload) => {
    state.outlets.data = {
      data: {
        data: []
      }
    };
  },
  LOAD_OUTLETS_SUCCESS: (state, payload) => {
    let data = [];

    if (!payload.forceKeep) {
      state.outlets.data = payload;
    } else {

      let currentData = [];
      let newData = [];
  
      if (
        payload.data &&
        payload.data.data &&
        payload.data.data.length
      ) newData = payload.data.data;
  
      if (
        state.outlets.data &&
        state.outlets.data.data &&
        state.outlets.data.data.data &&
        state.outlets.data.data.data.length
      ) currentData = state.outlets.data.data.data;
      
      data = [...currentData, ...newData];

      data = uniqBy(data, function (e) {
        return e.id;
      });

      if (!state.outlets.data) {
        state.outlets.data = {
          data: {
            data: [],
            pagination: undefined
          }
        }
      }

      state.outlets.data.data.data = data;
      state.outlets.data.data.pagination = payload.data.pagination;
    }

    state.outlets.error = null;
  },
  LOAD_OUTLETS_FAIL: (state, payload) => {
    state.outlets.data = null;
    state.outlets.error = payload;
  }
};

const getters = {
  optionsToSelect: state => {
    if (!state.outlets.data) return [];

    if (state.outlets.data &&
      state.outlets.data.data &&
      state.outlets.data.data.data
    ) 
      return state.outlets.data.data.data.map(item => {
        return {
          id: item.id,
          name: item.name,
        }
      });
  },
}

const actions = {
  getOutlets: ({ state, commit, rootState }, { 
    projectId,
    filterValues, 
    pagination, 
    forceKeep = false 
  }) => {
    return new Promise((result, reject) => {
      commit('LOAD_OUTLETS_BUSY', true);
      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };
  
      //in this case in pagination we will only have:searchQuery and perPage since this is a select list
      let query = '';	    //in this case in pagination we will only have:searchQuery and perPage since this is a select list
      const normalizedPagination = normalize(pagination);
      if(normalizedPagination) {
        query = '?';
        Object.keys(normalizedPagination).map((param, i) => {
            query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
          }
        );
      }
      
      if (filterValues) {
        const filtersQuery = filtersToQuery(filterValues);
        if (filtersQuery != '') {
          query += '&' + filtersQuery;
        }
      }
  
      return Axios
        .get(`${API_HOST}/analysis/${projectId}/outlets${query}`, config)
        .then(response => {
          response.data.forceKeep = forceKeep;
          commit('LOAD_OUTLETS_SUCCESS', response.data)
          result(state.outlets.data);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')});
  
          console.error(error);
          commit('LOAD_OUTLETS_FAIL', error);
          reject(error);
        })
        .finally(() => commit('LOAD_OUTLETS_BUSY', false));

    });
  },
  clearOutlets: ({ commit } ) => {
    commit('CLEAR_OUTLETS');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};